import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { firestoreConnect } from 'react-redux-firebase';
import { withStyles } from "@material-ui/styles";
import { styles } from "../../layout/Layout.styles";
import { theme } from "../../layout/Layout.theme";
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography/Typography";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem.js";

class Dashboard extends React.Component {
  render () {
    // const { classes } = this.props;
    return (
      <Fragment>
        <div style={{display: "flex"}}>
          <Paper
            style={{
              margin: '20px',
              padding: '20px',
              width: '350px',
            }}>
            <Typography variant="h6" style={{margin: '10px 0', }}>
              How to Enter Participation
            </Typography>
            <Typography variant="body2" align="left">
              Devotional group leaders should record participation each week during devotional group meetings.
              The intention is that accountability tracking should be done as part of a cultural
              consideration process during group so that participation can be considered and agreements
              can be made.
            </Typography>
            <Typography variant="body1" align="left" style={{margin: '10px 0', }}>
              <Link to={`/participation`}>Click here</Link> to enter Participation.
            </Typography>
          </Paper>
          <Paper
            style={{
              margin: '20px',
              padding: '20px',
              width: '350px',
            }}>
            <Typography variant="h6" style={{margin: '10px 0', }}>
              Making Changes & Getting Help
            </Typography>
            <Typography variant="body2" align="left">
              We are happy to help you with stuff like:
            </Typography>
            <List dense={true}>
              <ListItem><Typography variant="body2" align="left">
                - Someone left or joined my group
              </Typography> </ListItem>
              <ListItem><Typography variant="body2" align="left">
                - I want another group member to be able to enter participation for me
              </Typography> </ListItem>
              <ListItem><Typography variant="body2" align="left">
                - There's a typo in someone's name
              </Typography> </ListItem>
              <ListItem><Typography variant="body2" align="left">
                - Something's not working
              </Typography> </ListItem>
              <ListItem><Typography variant="body2" align="left">
                - Other questions/concerns
              </Typography> </ListItem>
            </List>
            <Typography color="primary" variant="body2" align="left">
              Email the admin: <strong>admin@therealityway.com</strong>
            </Typography>
          </Paper>
          <Paper
            style={{
              margin: '20px',
              padding: '10px 20px',
              width: '400px',
            }}>
            <Typography variant="h6" style={{margin: '10px 0', }}>
              Who Has Access?
            </Typography>
            <Typography variant="body2" align="left" paragraph>
              Only verified Devotees who have registered their gmail with Cultural Services can log in here.
            </Typography>
            <Typography variant="body2" align="left" paragraph>
              Devotional Group Leaders can see information for their groups only.
              Devotional Group Leaders may request that a group member be given login privileges
              to assist with recording information for their own group.
            </Typography>
            <Typography variant="body2" align="left" paragraph>
              Administrators, including Cultural Services, can see data for all devotees and groups.
              Administrators can also export data in order to create reports or save information
              in the Adidam Gateway database.
            </Typography>
          </Paper>
        </div>
        <div style={{display: "flex"}}>
          <Paper
            style={{
              margin: '20px',
              padding: '20px',
              width: '350px',
            }}>
            <Typography variant="h6" style={{margin: '10px 0', }}>
              What Ifs?
            </Typography>
            <Typography variant="body2" align="left">
              This is the beginning of an evolving cultural process, and there are bound to be questions
              about what participation means in a variety of cases. Was it a Yes, No or Agreement?
            </Typography>
            <Typography variant="body2" align="left" style={{marginTop: '10px'}}>
              <strong>Use your highest level of understanding</strong> as a group leader based on your
              cultural training, communications from Cultural Services, and your study of Bhagavan Adi Da's Word.
              You can also contact LC Cultural Services for more info. As questions arise, there
              will be ongoing clarification.
            </Typography>
          </Paper>
        </div>
      </Fragment>
    )
  }
}

export default compose(
  firestoreConnect(['devotionalGroups', 'devotees']), // or { collection: 'todos' }
  // connect(),
)(
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(Dashboard));
